import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePartnerAuth } from '../../context/PartnerAuthContext';

/**
 * Gates a partner portal route. While the stored token is being verified it
 * renders a spinner rather than redirecting, so a valid session never flashes
 * the sign-in screen on refresh.
 */
const PartnerProtectedRoute: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const { partner, loading } = usePartnerAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface">
        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-primary-500" />
      </div>
    );
  }

  if (!partner) {
    return (
      <Navigate to="/partner/login" replace state={{ from: location.pathname }} />
    );
  }

  return children;
};

export default PartnerProtectedRoute;
